<template>
  <div class="task">
    <div class="look-nav">
      <div class="handle-wrapper" @click="backPath"><div class="icon-font">&#xe612;</div>返回</div>
      <div class="look-nav-center">发布任务</div>
      <div class="handle-wrapper" @click="handleValue"><div class="icon-font">&#xe678;</div>提交</div>
    </div>
    <div class="release-content">
      <div class="release-list">
        <div class="input-contain">
          <div class="input-title">任务名称：</div>
          <div class="input-wrapper">
            <input v-model="inputValue.taskName" placeholder=""/>
          </div>
        </div>
        <div class="input-contain">
          <div class="input-title" style="padding-left: 0.89vw">负责人：</div>
          <DropDownInput type="1" :items="custodianValue" content="" @sendValue="sendValue" @sendInfo="showInfo"></DropDownInput>
        </div>
        <div class="input-contain">
          <div class="input-title">办理日期：</div>
          <div class="input-wrapper">
            <el-date-picker
              v-model="inputValue.dealTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择办理日期">
            </el-date-picker>
          </div>
        </div>
        <div class="input-contain">
          <div class="input-title">完成日期：</div>
          <div class="input-wrapper">
            <el-date-picker
              v-model="inputValue.finishTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择完成日期">
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="text-area-wrapper">
        <div class="text-area-title">任务详情：</div>
        <textarea v-model="inputValue.taskDetail" class="text-area-input"></textarea>
      </div>
    </div>
    <img class="task-icon" src="../../../assets/content-box.png"/>
  </div>
</template>

<script>
import DropDownInput from '../../../components/DropDownInput.vue'
import {userList} from '../../../api/system'
import {addTask} from '../../../api/maintain'
import {noEmpty} from '../../../tools/methods'
export default {
  name: 'Release',
  components: { DropDownInput },
  data () {
    return {
      custodianValue: [],
      inputValue: {
        taskName: '',
        principalId: '',
        principalName: '',
        dealTime: '',
        finishTime: '',
        taskDetail: ''
      }
    }
  },
  created () {
    this.handleSearchValue()
  },
  methods: {
    backPath: function () {
      this.$router.go(-1)
    },
    showInfo: function (data) {
      console.log(data)
      this.inputValue.principalId = data.id
      this.inputValue.principalName = data.name
    },
    sendValue: function (value) {
      this.handleSearchValue(value)
    },
    handleSearchValue: function (value) {
      let body = {
        keywork: value,
        page: 1,
        rows: 9999
      }
      userList(body).then(res => {
        console.log(res)
        this.custodianValue = res.data.rows
      }).catch(err => {
        console.log(err)
      })
    },
    handleValue: function () {
      if (
        noEmpty(this.inputValue.taskName, '请输入任务名称') &&
        noEmpty(this.inputValue.principalId, '请选择任负责人') &&
        noEmpty(this.inputValue.dealTime, '请选择办理日期') &&
        noEmpty(this.inputValue.finishTime, '请选择完成日期') &&
        noEmpty(this.inputValue.taskDetail, '请输入任务详情')
      ) {
        console.log(this.inputValue)
        addTask(this.inputValue).then(res => {
          console.log(res)
          this.$message({
            message: res.data,
            type: 'success',
            center: 'true',
            duration: '1000'
          })
          this.$router.go(-1)
        }).catch(err => {
          console.log(err)
        })
      }
    }
  }
}
</script>

<style scoped>
@import "./Task.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/task/Release.vue